import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FiCopy, FiCheck } from 'react-icons/fi';
import { employeesService } from 'services';
import { errorFormating, getAppName } from 'utils/utils';
import Loading from 'components/Loading';

const EmployeeInvitationLinkModal = ({ closeModal, employee }) => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(true);
	const [invitation, setInvitation] = useState(null);
	const [error, setError] = useState(null);
	const [copied, setCopied] = useState(false);

	useEffect(() => {
		const fetchInvitation = async () => {
			try {
				setLoading(true);
				setError(null);
				const response = await employeesService.getInvitation(employee.id);

				if (response.ok) {
					setInvitation(response);
				} else {
					const textError = errorFormating(response);
					setError(textError.general || t('invitationLink.fetchError'));
				}
			} catch (err) {
				setError(t('invitationLink.fetchError'));
			} finally {
				setLoading(false);
			}
		};

		fetchInvitation();
	}, [employee.id]);

	const getInvitationLink = () => {
		if (!invitation || !invitation.token) return '';
		const origin = window.location.origin;
		return `${origin}/invitation/${invitation.token}`;
	};

	const handleCopyLink = async () => {
		const link = getInvitationLink();
		if (link) {
			try {
				await navigator.clipboard.writeText(link);
				setCopied(true);
				setTimeout(() => setCopied(false), 2000);
			} catch (err) {
				const textArea = document.createElement('textarea');
				textArea.value = link;
				document.body.appendChild(textArea);
				textArea.select();
				document.execCommand('copy');
				document.body.removeChild(textArea);
				setCopied(true);
				setTimeout(() => setCopied(false), 2000);
			}
		}
	};

	if (loading) {
		return (
			<div className="modal-content" style={{ width: '500px' }}>
				<div className="modal-body">
					<Loading />
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className="modal-content" style={{ width: '500px' }}>
				<div className="modal-body">
					<p>{error}</p>
				</div>
			</div>
		);
	}

	if (!invitation || invitation.used) {
		const appName = getAppName();
		const loginUrl = appName === 'Plain' ? 'https://app.plain.ninja/login' : 'https://hr.haddock.app/login';
		const rememberPasswordUrl = appName === 'Plain' ? 'https://app.plain.ninja/remember-password' : 'https://hr.haddock.app/remember-password';

		return (
			<div style={{ width: '500px' }}>
				<div className="modal-body">
					<p>
						{t('invitationLink.usedP1Pre', { appName })} <b>{t('invitationLink.usedP1Bold')}</b>
					</p>
					<p>
						{t('invitationLink.usedP2Pre')} <b>{t('invitationLink.usedP2Bold')}</b>{' '}
						<a href={loginUrl} target="_blank" rel="noopener noreferrer">
							{loginUrl}
						</a>
					</p>
					<p>
						{t('invitationLink.usedP3Pre')}{' '}
						<a href={rememberPasswordUrl} target="_blank" rel="noopener noreferrer">
							{t('invitationLink.forgotPassword')}
						</a>
						.
					</p>
					<p>{t('invitationLink.contactUs')}</p>
				</div>
			</div>
		);
	}

	const invitationLink = getInvitationLink();

	return (
		<div style={{ width: '500px' }}>
			<div className="modal-body">
				<p>
					{t('invitationLink.shareWithPre')} <strong>{employee.name} {employee.surname}</strong> {t('invitationLink.shareWithPost')}
				</p>
				<div className="form-group">
					<label>{t('invitationLink.linkLabel')}</label>
					<div className="input-group">
						<input
							type="text"
							className="form-control"
							value={invitationLink}
							readOnly
							style={{ fontFamily: 'monospace', fontSize: '12px' }}
						/>
						<button
							type="button"
							className={`btn ${copied ? 'btn-success' : 'btn-outline-primary'}`}
							onClick={handleCopyLink}
							title={copied ? t('invitationLink.copied') : t('invitationLink.copy')}
						>
							{copied ? <FiCheck /> : <FiCopy />}
						</button>
					</div>
				</div>
				{invitation.sendings > 0 && (
					<p className="text-muted" style={{ fontSize: '12px', marginTop: '10px' }}>
						{t('invitationLink.sentCount', { count: invitation.sendings })}
					</p>
				)}
			</div>
		</div>
	);
};

export default EmployeeInvitationLinkModal;
